import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const NewsDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lightboxImage, setLightboxImage] = useState(null);
  const contentRef = React.useRef(null);

  // Get current page URL for sharing
  const shareUrl = encodeURIComponent(window.location.href);
  const shareTitle = post ? encodeURIComponent(post.title.rendered) : "";

  // Make images in WordPress content clickable to open in lightbox
  useEffect(() => {
    if (contentRef.current && !lightboxImage) {
      const images = contentRef.current.querySelectorAll('img');
      images.forEach((img) => {
        // Remove WordPress inline width/height attributes
        img.removeAttribute('width');
        img.removeAttribute('height');
        // Apply constrained styles
        img.style.cssText = 'max-width: 100% !important; height: auto !important; cursor: pointer; border-radius: 8px; display: block; margin: 20px auto;';
        img.onclick = () => setLightboxImage(img.src);
      });
    }
  }, [post, lightboxImage]);

  // Close lightbox on Escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') setLightboxImage(null);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await axios.get(`https://cms.nausurology.org/wp-json/wp/v2/posts?slug=${slug}&_embed`);
        if (res.data.length > 0) setPost(res.data[0]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [slug]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    alert("Link copied! You can now paste it on Instagram.");
  };

  if (loading) return <div style={{ padding: '100px', textAlign: 'center' }}>Opening Article...</div>;
  if (!post) return <div style={{ padding: '100px', textAlign: 'center' }}>Article not found.</div>;

  const imageUrl = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '60px 20px', fontFamily: 'sans-serif' }}>
      <button onClick={() => navigate('/news')} style={{ background: 'none', border: 'none', color: '#064e3b', cursor: 'pointer', marginBottom: '20px', fontWeight: 'bold' }}>
        ← Back to News
      </button>

      <h1 style={{ fontSize: '40px', color: '#064e3b', marginBottom: '10px', lineHeight: '1.2' }} dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
      <p style={{ color: '#666', marginBottom: '30px' }}>{new Date(post.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

      {imageUrl && (
        <div style={{ width: '100%', maxHeight: '500px', overflow: 'hidden', borderRadius: '15px', marginBottom: '40px', backgroundColor: '#f9f9f9', display: 'flex', justifyContent: 'center' }}>
          <img src={imageUrl} alt="" style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }} />
        </div>
      )}

      <div
        ref={contentRef}
        style={{ lineHeight: '1.8', fontSize: '18px', color: '#333', marginBottom: '50px' }}
        dangerouslySetInnerHTML={{ __html: post.content.rendered }}
      />

      <hr style={{ border: 'none', borderTop: '1px solid #eee', marginBottom: '30px' }} />

      {/* SOCIAL SHARING SECTION */}
      <div style={{ textAlign: 'center' }}>
        <h3 style={{ fontSize: '14px', color: '#999', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '20px' }}>Share this Update</h3>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
          
          {/* WhatsApp */}
          <a href={`https://api.whatsapp.com/send?text=${shareTitle}%20${shareUrl}`} target="_blank" rel="noreferrer" 
             style={{ ...btnStyle, backgroundColor: '#25D366' }}>WhatsApp</a>

          {/* Facebook */}
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`} target="_blank" rel="noreferrer" 
             style={{ ...btnStyle, backgroundColor: '#1877F2' }}>Facebook</a>

          {/* Twitter (X) */}
          <a href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`} target="_blank" rel="noreferrer" 
             style={{ ...btnStyle, backgroundColor: '#000000' }}>Twitter</a>

          {/* Instagram / General Copy */}
          <button onClick={copyToClipboard} 
             style={{ ...btnStyle, backgroundColor: '#E1306C', border: 'none', cursor: 'pointer' }}>Copy Link (Insta)</button>

        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxImage && (
        <div
          onClick={() => setLightboxImage(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            cursor: 'pointer',
            padding: '20px'
          }}
        >
          <img
            src={lightboxImage}
            alt=""
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '90%',
              maxHeight: '90vh',
              objectFit: 'contain',
              borderRadius: '8px',
              cursor: 'default'
            }}
          />
          <button
            onClick={() => setLightboxImage(null)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '32px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
};

// Common style for sharing buttons
const btnStyle = {
  padding: '10px 20px',
  borderRadius: '30px',
  color: 'white',
  textDecoration: 'none',
  fontSize: '13px',
  fontWeight: 'bold',
  transition: 'opacity 0.2s'
};

export default NewsDetail;